import { request } from "../utils/request"

/**
 * create 接收实例
 * @param data 
 * @returns 
 */
export const createProtoReceiver = (data: { name: string; protocol: number | null; comment: string }) => {
    return request.post('/proto/receive/create', data)
}

/**
 * update 接收实例
 * @param data 
 * @returns 
 */
export const updateProtoReceiver = (data: { id: number; name: string; protocol: number | null; comment: string }) => {
    return request.post('/proto/receive/update', data)
}

/**
 * 刷新 接收实例密钥
 * @param id 
 * @returns 
 */
export const updateProtoReceiverAk = (id: number) => {
    return request.get('/proto/receive/update/ak/' + id)
}

/**
 * fetch 分页上报用户数据
 * @param params 
 * @returns 
 */
export const getProtoReceivers = (params: { page: number, limit: number }) => {
    return request.get('/proto/receive', { params })
}

/**
 * 获取分页协议模版
 * @param params 
 * @returns 
 */
export const getProtos = (params: { page: number, limit: number }) => {
    return request.get('/proto', { params })
}

/**
 * fetch 所有协议模版
 * @returns 
 */
export const getAllProtos = () => {
    return request.get('/proto/all')
}

/**
 * create 协议模版
 * @param data 
 * @returns 
 */
export const createProto = (data: { name: string; code: string, comment: string }) => {
    return request.post('/proto/create', data)
}

/**
 * update 协议模版
 * @param data 
 * @returns 
 */
export const updateProto = (data: { id: number, name: string; code: string, comment: string }) => {
    return request.post('/proto/update', data)
}